<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top">
            <el-row>
                <el-col :span="4">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">考试名称：</div>
                        <el-input v-model="artName" placeholder="请输入名称" style="width: 150px;" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">考试分类：</div>
                        <el-cascader v-model="categoryId" :options="sortList" style="width: 150px;"
                            clearable></el-cascader>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">考试开始时间：</div>
                        <el-date-picker v-model="beginTime" placeholder="请选择" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">考试结束时间：</div>
                        <el-date-picker v-model="endTime" placeholder="请选择" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="2" :offset="2">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="getList()">查询</el-button>
                        <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="whiteBg main-middle">
            <div class="box box-align-center mt-btns">
                <el-button type="primary" plain icon="el-icon-plus" @click="buildNewTopic">创建考试</el-button>
            </div>
            <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" ref="table"
                v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="pageSize"
                @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
        </div>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import { examSelectList, zgsourceAllCategory, examDelete } from '@/api/index2';

var that = null;
export default {
    components: {
        DyTable
    },
    data() {
        const { delArticle } = this;
        const { editArticle } = this;
        const { fxArticle } = this;
        return {
            artName: '',
            tableLoading: false,
            dialogTitle: '创建考试',
            columns: [
                {
                    type: 'index',
                    title: '序号',
                },
                {
                    key: 'name',
                    title: '考试名称',
                },
                {
                    key: 'categoryName',
                    title: '考试分类',
                },
                {
                    key: 'beginTimeStr',
                    title: '考试开始时间',
                },
                {
                    key: 'endTimeStr',
                    title: '考试结束时间',
                },
                {
                    key: 'bgUserName',
                    title: '操作人',
                },
                {
                    key: 'updateDate',
                    title: '最后更新时间',
                },
                {
                    key: '',
                    title: '操作',
                    width: 200,
                    render: ({ row }) => {
                        return (
                            <div>
                                <el-link type='primary' onClick={() => editArticle(row)}>
                                    编辑
                                </el-link>
                                {/* <el-link type='primary' style='margin-left:12px' onClick={() => fxArticle(row.id)}>
                                    考试分析
                                </el-link> */}
                                <el-link type='danger' style='margin-left:12px' onClick={() => delArticle(row.id)}>
                                    删除
                                </el-link>
                            </div>
                        )
                    },
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            ruleForm: {
                //新建直播表单数据
                commonId: '',
                endTime: '',
                id: '',
                image: '',
                jumpStr: '',
                liveCover: '',
                jumpType: '',
                name: '',
                platform: '',
                startTime: '',
                labelName: '',
                userType: '',
                weight: '',
            },
            rules: {
                name: [{ required: true, message: '请输入考试名称', trigger: 'blur' }],
                // image: [{ required: true, message: '请上传图片', trigger: 'change' }],
            },
            addVisible: false,
            categoryId: '',
            beginTime: null,
            endTime: null,
            updateTime: null,
            sortList: []
        };
    },
    mounted() {
        that = this;
        that.getList();
        that.getCourseCategory();
    },
    computed: {
        uploadImg() {
            return host.uploadImgUrl;
        },
        headers() {
            return {
                'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
            };
        },
    },
    methods: {
        //考试分析
        fxArticle() {

        },
        //新建考试
        buildNewTopic() {
            that.$router.push({
                path: '/setExam',
                query: {
                    type: 2,
                }
            });
        },
        //重置列表
        resetList() {
            that.currentPage = 1;
            that.artName = '';
            that.categoryId = '';
            that.beginTime = null;
            that.endTime = null;
            that.getList();
        },
        //编辑考试
        editArticle(obj) {
            console.log(obj, '编辑');
            that.$router.push({
                path: '/setExam',
                query: {
                    type: 2,
                    id: obj.id
                }
            });
        },
        //删除考试
        delArticle(id) {
            that.$confirm('确认要删除此考试吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let info = {
                    id,
                    isDelete: 1
                };
                console.log(info);
                examDelete(info).then((res) => {
                    this.$message({
                        showClose: true,
                        message: '删除成功',
                        type: 'success',
                    });
                    that.getList();
                });
            });
        },
        onCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },
        getCourseCategory() {
            let param = {
                type: 3,
            }
            zgsourceAllCategory(param).then((res) => {
                if (res.result == 1) {
                    console.log('考试分类', res);
                    that.sortList = that.listFor(res.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },
        getList() {
            that.tableLoading = true;
            let info = {
                name: that.artName,
                categoryId: that.categoryId ? that.categoryId[0] : '',
                beginTime: that.beginTime,
                endTime: that.endTime,
                type: 2,
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true,
            };
            console.log(info);
            examSelectList(info).then((res) => {
                if (res.result == 1) {
                    console.log('考试列表', res);
                    let ress = res.data;
                    that.total = ress.total;
                    that.currentPage = ress.pageNum;
                    that.tableData = ress.list;
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.main-top {
    padding: 20px 15px;
    border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
    }
}

.main-middle {
    padding: 15px 11px;
}
</style>